// PWA 快取管理工具
class CacheManager {
  constructor() {
    this.APP_VERSION = '1.0.1';
  }

  // 清除授權相關快取
  async clearAuthCache() {
    
    try {
      // 清除 localStorage 中的授權資料
      const authKeys = ['token', 'user', 'lineRoles', 'selectedRole'];
      authKeys.forEach(key => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      });

      
      return true;
    } catch (error) {
      return false;
    }
  }

  // 清除所有快取
  async clearAllCache() {
    
    try {
      // 清除所有 localStorage 和 sessionStorage
      localStorage.clear();
      sessionStorage.clear();

      
      return true;
    } catch (error) {
      return false;
    }
  }

  // 檢查是否需要更新
  checkForUpdates() {
    const lastVersion = localStorage.getItem('app_version');
    const currentVersion = this.APP_VERSION;
    
    
    if (lastVersion && lastVersion !== currentVersion) {
      this.clearAuthCache().then(() => {
        localStorage.setItem('app_version', currentVersion);
        // 可以在這裡顯示更新提示
        if (window.confirm('發現應用程式更新，是否重新載入以套用最新版本？')) {
          window.location.reload();
        }
      });
    } else {
      localStorage.setItem('app_version', currentVersion);
    }
  }

  // 強制重新整理（用於LINE授權失敗時）
  async forceRefreshAuth() {
    
    await this.clearAuthCache();
    
    // 重新導向到首頁
    window.location.href = '/';
  }

  // 檢測PWA安裝狀態
  isPWAInstalled() {
    return window.matchMedia('(display-mode: standalone)').matches ||
           window.navigator.standalone === true;
  }

  // PWA安裝提示
  promptPWAInstall() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult) => {
        this.deferredPrompt = null;
      });
    }
  }
}

// 創建全域實例
const cacheManager = new CacheManager();

// 初始化
if (typeof window !== 'undefined') {
  // 監聽PWA安裝事件
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    cacheManager.deferredPrompt = e;
  });

  // 頁面載入時檢查更新
  window.addEventListener('load', () => {
    cacheManager.checkForUpdates();
  });
}

export default cacheManager;